import { Sun, Moon, ShieldCheck } from "@phosphor-icons/react";

export const Header = ({ theme, toggleTheme }) => {
  return (
    <header
      data-testid="app-header"
      className="glass sticky top-0 z-50 border-b border-border/60"
    >
      <div className="mx-auto flex h-16 max-w-[1500px] items-center justify-between px-5 lg:px-8">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-lg shadow-primary/30">
            <ShieldCheck weight="fill" size={22} />
          </div>
          <div className="leading-tight">
            <div className="font-head text-lg font-bold tracking-tight">Sentinel<span className="text-primary"> Qi</span> <span className="font-normal text-muted-foreground">1.0</span></div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">autonomous ai testing</div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-xs font-medium text-muted-foreground sm:flex">
            <span className="h-2 w-2 rounded-full bg-[hsl(var(--success))] pulse-dot" />
            Claude Sonnet 4.6
          </span>
          <button
            data-testid="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            className="flex h-9 w-9 items-center justify-center rounded-xl border border-border bg-card text-foreground transition-colors hover:bg-accent focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            {theme === "dark" ? <Sun size={18} weight="bold" /> : <Moon size={18} weight="bold" />}
          </button>
        </div>
      </div>
    </header>
  );
};
